import React from 'react';

const OffersContext = React.createContext();

export const OffersContextProvider = ({ children, offers }) => (
  <OffersContext.Provider value={offers}>{children}</OffersContext.Provider>
);

export default OffersContext;
